module.exports = __webpack_public_path__ + "static/media/img3dCloner.51f52221.png";